import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';

interface DateChangeIconProps {
  dateChangeVerification: boolean;
  active: boolean;
}

export const DateChangeIcon: React.FC<DateChangeIconProps> = props => {
  const { t, tk } = useTranslation('projectLng');
  return (
    <>
      {props.dateChangeVerification && props.active && (
        <OverlayTrigger
          overlay={
            <Tooltip>{t(tk.projects.dateChangeVerificationWaiting)}</Tooltip>
          }
        >
          <div className="px-2">
            <Icon.CalendarCheckFill className="icon-red" />
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};
